interface BrandWordmarkProps {
  hiredClassName?: string;
  coachClassName?: string;
  className?: string;
}

const BrandWordmark = ({
  hiredClassName = "text-[#4f9ecb] font-bold",
  coachClassName = "text-[#334763] font-bold",
  className,
}: BrandWordmarkProps) => {
  return (
    <span className={className}>
      <span className={hiredClassName}>Hired</span>
      <span className={coachClassName}>Coach</span>
    </span>
  );
};

export default BrandWordmark;
